export enum RegExpEnum {
	LATIN_ONLY = '^[A-Za-z0-9!@#$%^&*()_+\\-=\\[\\]{};\':"\\\\|,.<>/?]+$', // Только латинские буквы, цифры и спецсимволы
	UPPERCASE = '[A-Z]', // Хотя бы одна заглавная буква
	LOWERCASE = '[a-z]', // Хотя бы одна строчная буква
	SPECIAL_CHARACTER = '[!@#$%^&*()_+\\-=\\[\\]{};\':"\\\\|,.<>/?]', // Хотя бы один спецсимвол
	DIGIT = '\\d', // Хотя бы одна цифра,
	TRAILING_DECIMAL_ZEROS_BEFORE_SUFFIX = '\\.0+(?=\\D|$)', // Удаляет .0+ перед суффиксами или в конце строки
	THOUSANDS_SEPARATOR = '\\B(?=(?:\\d{3})+(?!\\d))', // Вставляет пробелы между тысячами
	OPTION_SYMBOL = '^([A-Z0-9]+)(\\d{2})(\\d{2})(\\d{2})([CP])(\\d{8})$', // Деление тикера опциона на Символ, тип, страйк цену, дату
	MAC_PLATFORM = 'Mac|iP', // Для определения платформ Apple (Mac, iPhone, iPad)
	LATIN_ALPHANUMERIC = '^[a-zA-Z0-9]+$', // Только латинские буквы и цифры
	NAME_LATIN = '^[A-Za-z]+(?:[- ][A-Za-z]+)*$', // Только латинские буквы, пробелы и дефисы
	SECONDS_EXTRACT = '(\\d+)\\s+seconds', // Извлекает число секунд из строки
}
